import { useLocation } from '../../../../context/LocationContext';
import { DeliveryMethodDtoTypeEnum } from '../../../../../generated-api';
import { useCheckout } from '../../../../context/CheckoutContext';
import classNames from 'classnames';
import React from 'react';

const EatInOrTakeaway = () => {
  const { location } = useLocation();
  const { vatType, setVatType } = useCheckout();

  const takeaway = location.deliveryMethods.find((method) => method.type === DeliveryMethodDtoTypeEnum.TAKEAWAY);
  const counter = location.deliveryMethods.find((method) => method.type === DeliveryMethodDtoTypeEnum.COUNTER);
  const table = location.deliveryMethods.find((method) => method.type === DeliveryMethodDtoTypeEnum.TABLE);

  if (!takeaway && !table && !counter) return null;

  if (!takeaway) {
    return <></>;
  }

  const className = (selected: boolean) =>
    classNames({
      'text-center text-nowrap border flex items-center h-6 py-4 text-sm hover:opacity-75': true,
      'text-brand-primary font-semibold': selected,
      'neutral border-grey-medium ': !selected,
    });

  return (
    <div className="flex">
      <div className="inline-flex items-center">
        <input id="EAT_IN" type="radio" onChange={() => setVatType('EAT_IN')} checked={vatType === 'EAT_IN'} hidden />
        <label htmlFor="EAT_IN" className={`${className(vatType === 'EAT_IN')} pr-3 pl-4 rounded-l-full`}>
          Eat In
        </label>
      </div>
      <div className="inline-flex items-center">
        <input
          type="radio"
          id="TAKEAWAY"
          checked={vatType === 'TAKEAWAY'}
          onChange={() => setVatType('TAKEAWAY')}
          hidden
        />
        <label htmlFor="TAKEAWAY" className={`${className(vatType === 'TAKEAWAY')} pl-2 pr-4 rounded-r-full`}>
          Takeaway
        </label>
      </div>
    </div>
  );
};

export default React.memo(EatInOrTakeaway);
